import lodash from "lodash";
import { Button, Col, Empty, Row, Typography } from "antd";
import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import CardDocument from "component/cards/bailiff/card_document";
import CardDocumentSke from "component/cards/bailiff/card_document_ske";
import { LeftOutlined } from "@ant-design/icons";
import { defaultBailiffAllSelector } from "store/bailiff/draft/bailiff/default_bailiff.selector";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
const BailiffDetail = () => {
  // -------------------------- VAR -----------------------------
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  const bailiffs = useSelector(defaultBailiffAllSelector);
  const sorted = lodash.orderBy(bailiffs, "createAt", "desc") || [];

  console.log({ bailiffs });
  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  const renderLists = () => {
    if (sorted?.length > 0) {
      return (
        <Row gutter={[5, 10]}>
          {sorted?.map((item) => (
            <Col key={item?.id} xl={6} lg={6} md={8} xs={12}>
              <CardDocument data={item} />
            </Col>
          ))}
        </Row>
      );
    }
  };

  const renderEmpty = () => {
    if (sorted?.length === 0) {
      return (
        <div
          style={{
            minHeight: 200,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Empty description="Chưa có file nào" />
        </div>
      );
    }
  };

  const renderSkele = () => {
    if (sorted === null) {
      return (
        <Row gutter={[10, 10]}>
          {sorted?.map((item) => (
            <Col key={item?.id} xl={6} lg={6} md={8} xs={12}>
              <CardDocumentSke data={item} />
            </Col>
          ))}
        </Row>
      );
    }
  };
  // -------------------------- MAIN ----------------------------
  return (
    <Row style={{ padding: 5 }}>
      <Col style={{ paddingTop: 30 }} xl={24} lg={24} md={24} xs={24}>
        <Button
          href="/"
          size="large"
          type="link"
          style={{ textDecoration: "underline" }}
          icon={<LeftOutlined />}
        >
          Khách hàng
        </Button>
      </Col>
      <Col xl={24} lg={24} md={24} xs={24}>
        <Typography.Title style={{ color: "gray" }} level={4}>
          Danh sách Files
        </Typography.Title>
      </Col>
      <Col xl={24} lg={24} md={24} xs={24}>
        {renderLists()}
        {renderEmpty()}
        {renderSkele()}
      </Col>
    </Row>
  );
};
export default BailiffDetail;
